/**
 * @file        src/pages/flight/CorporateUsedCoupons.jsx
 * @description Corporate Flight → Used Coupon List. Same list as the B2C
 *              Flight Used Coupon List (UsedCoupons.jsx), fixed to
 *              audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import UsedCoupons from './UsedCoupons';

export default function CorporateUsedCoupons() {
  return (
    <UsedCoupons
      title="Corporate Used Coupon List"
      subtitle="Corporate Flight · B2B coupons applied on bookings"
      audience="b2b"
    />
  );
}
